export const CANVAS_SIZE = 4000;
export const GRID_SIZE = 10;
/** World-space padding so side controls are not clipped on small shapes */
export const OVERLAY_CONTROL_GUTTER = 56;

export const DEFAULT_ITEM_COLORS = {
  rectangle: { fill: 0xffffff, border: 0x333333 },
  circle: { fill: 0xffffff, border: 0x333333 },
  sticky: { fill: 0xfff740, border: 0xfff740 },
  text: { fill: 0xffffff, border: 0xcccccc },
};
